import * as React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: 20,
    borderTopColor: "#EDEDED",
    borderTopWidth: 1,
    textAlign: "center",
    fontSize: 10,
    fontFamily: "MontserratRegular",
  },
});
const PDFCompanyFooter = () => (
  <View style={styles.footer} fixed>
    <Text>
      http://segpi.wesizwe.com/ Tel: +27 11 994 4600 Fax: +27 11 994 4601
    </Text>
  </View>
);
export default PDFCompanyFooter;
